import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Table, notification } from "antd";
import moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import JsonToXlsxDownload from "../utils/JsonToXlsxDownload";
import { CallFindAllUsersByParams, CallUpdateStatus } from "../services/apiAction";
import { set } from "react-hook-form";

const Master = () => {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCounts, setTotalCounts] = useState(0);
  const [userCounts, setUserCounts] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const defaultPage = 1;
  const defaultLimit = 20;
  const defaultSearch = "";
  const defaultRole = "applicant";

  const pageNo = parseInt(searchParams.get("page") || defaultPage);
 console.log("check page::::::::::-", pageNo );

  const limit = parseInt(searchParams.get("limit") || defaultLimit);
  const searchTerm = searchParams.get("search") || defaultSearch;
  const role = searchParams.get("role") || defaultRole;

  const [search, setSearch] = useState(searchTerm);

  const fetchData = async (page = pageNo, limitVal = limit, searchVal = search) => {
    console.log("check val::::::::::-", page, limitVal, searchVal);
    
    setLoading(true);
    try {
      const query = `page=${page}&limit=${limitVal}&role=${role}${
        searchVal ? `&searchPara=${searchVal}` : ""
      }`;

      const res = await CallFindAllUsersByParams(query);
      if (res?.data?.message === "Success") {
        setData(
          res?.data?.admin?.map((item, index) => ({ ...item, key: index })) || []
        );
        setTotalCounts(res?.data?.totalCount || 0);
        setUserCounts(res?.data?.userCount || 0);
      } else {
        setData([]);
        setTotalCounts(0);
        setUserCounts(0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pageNo, limit, searchTerm);
  }, [pageNo, limit, searchTerm]);

  const handleEdit = async (id, status, name) => {
    try {
      const formData = new FormData();
      formData.append(name === "status" ? "status" : "isChecked", !status);

      const res = await CallUpdateStatus(id, formData);
      if (res?.data?.message === "Success") {
        api.success({ message: "Updated", duration: 2 });
        fetchData(pageNo, limit, search);
      }
    } catch {}
  };

  const handlePageChange = useCallback(
    (page, pageSize) => {
      setSearchParams({...searchParams,
        page: page.toString(),
        limit: pageSize.toString(),
      });
    },
    [search, role]
  );

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData(pageNo, limit, search);
    }, 500);

    return () => clearTimeout(delay);
  }, [search]);

  const columns = [
    {
      title: "Sr No.",
      render: (id, data, idx) => idx + 1 + limit * (pageNo - 1),
    },
    { title: "Name", render: (id, item) => `${item.firstName} ${item.lastName}` },
    { title: "Mobile", dataIndex: "mobile" },
    { title: "Email", dataIndex: "email" },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (date) => moment(date).format("ll"),
    },
    {
      title: "Status",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            defaultChecked={item?.status}
            onClick={() => handleEdit(item?._id, item?.status, "status")}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Checked",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            defaultChecked={item?.isChecked}
            onClick={() => handleEdit(item?._id, item?.isChecked, "checked")}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Action",
      render: (id, item) => (
        <Button
          tag={Link}
          to="/admin/user/adminListing"
          state={{
            schoolId: item?._id,
            role: "user",
            page: pageNo,
            limit: limit,
            search: search,
          }}
          size="sm"
          color="white"
          className="btn-light"
        >
          <i className="fas fa-eye text-primary" />
        </Button>
      ),
    },
  ];

  return (
    <Container className="my-5" fluid>
      {contextHolder}

      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 pb-0 d-flex justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
                <h3 className="mb-0 mr-3">User List</h3>

                <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                  <span className="mr-3 font-weight-bold">
                    Total Users:
                    <Button color="primary" className="ml-3 mr--3" size="sm">
                      {totalCounts}
                    </Button>
                  </span>
                </Card>
                <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                  <span className="mr-3 font-weight-bold">
                    Total Subusers:
                    <Button color="primary" className="ml-3 mr--3" size="sm">
                      {userCounts}
                    </Button>
                  </span>
                </Card>
              </div>

              <div className="d-flex align-items-center mt-2 mt-md-0">
                <div className="xlsxDownloadBtn p-2 mr-3">
                  <JsonToXlsxDownload jsonData={data} pageName="UserListing" />
                </div>

                <Input
                  placeholder="Search"
                  className="rounded-pill"
                  value={search}
                  type="search"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </CardHeader>

            <CardBody>
              <div className="table-responsive">
                <Table
                  dataSource={data}
                  columns={columns}
                  loading={loading}
                  pagination={{
                    current: pageNo,
                    pageSize: limit,
                    total: totalCounts,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePageChange,
                  }}
                  scroll={{ x: "max-content" }}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default Master;